enum HostTypeEnum {
  Website = 'Website',
  DesktopApp = 'DesktopApp'
}

export default HostTypeEnum;
